import { FC } from "react";
import { Typography } from "@mui/material";
import { useMatch, useParams } from "react-router-dom";
import { useSpecificCountry } from "../../dataHooks/countryQueries";
import { useIsMobileLayout } from "../../../../layout/useIsMobileLayout";

export const CountryMenu: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: country } = useSpecificCountry(id);

  // The sign-off page replaces the detail layout rather than opening over it, so the menubar says
  // which one you are on. Same treatment as the counterparty menubar.
  const onSignOff = Boolean(useMatch("/countries/country/:id/signoff"));

  const name = country?.countryName ?? "Country Addition";
  const isMobile = useIsMobileLayout();

  return (
    <Typography
      variant={isMobile ? "h6" : "h5"}
      component="span"
      noWrap
      sx={{ display: "block", minWidth: 0 }}
    >
      {onSignOff ? `Sign off: ${name}` : name}
    </Typography>
  );
};
